import { useAppSelector } from "integrations/redux/hooks"
import { selectEnabled, selectGridData, selectPDFLegendScale } from "../PDFSlice"
import { WebMercatorViewport } from "@deck.gl/core"
import { getLinePoints } from "./PDFCoordinateNotations"
import { useMemo } from "react"
import { BORDER_THICKNESS as EXPECTED_BORDER_THICKNESS } from "../PDFSnapshotContainer"

export const GridData = ({
    width,
    height,
    view,
    offsetX,
    offsetY,
}: {
    width: number
    height: number
    view: WebMercatorViewport
    offsetX: number
    offsetY: number
}) => {
    const borderEl = document.getElementById("annotation-border-element")
    const legendScale = useAppSelector(selectPDFLegendScale())

    const BORDER_THICKNESS = borderEl
        ? parseFloat(window.getComputedStyle(borderEl).getPropertyValue("border-width"))
        : EXPECTED_BORDER_THICKNESS * legendScale
    const minX = offsetX + BORDER_THICKNESS
    const minY = offsetY + BORDER_THICKNESS
    const enabled = useAppSelector(selectEnabled())
    const gridData = useAppSelector(selectGridData())
    const h = height - BORDER_THICKNESS * 2
    const w = width - BORDER_THICKNESS * 2
    const lines = useMemo(() => {
        const lines: React.FC[] = []
        const linePoints = getLinePoints(
            [
                [minX, minY],
                [minX + w, minY],
                [minX + w, minY + h],
                [minX, minY + h],
            ],
            view,
            gridData
        )
        if (linePoints.length <= 100)
            linePoints.forEach(([a, b]) => {
                lines.push(() => (
                    <line
                        x1={a.point[0]}
                        x2={b.point[0]}
                        y1={a.point[1]}
                        y2={b.point[1]}
                        stroke="black"
                        strokeWidth={0.5}
                    />
                ))
            })
        return lines
    }, [minX, minY, gridData, view, h, w])
    if (!enabled.gridlines) return null
    return (
        <>
            <svg viewBox={`0 0 ${w} ${h}`} height={h} width={w} className="absolute left-0 top-0">
                {lines.map((Line, idx) => (
                    <Line key={idx} />
                ))}
            </svg>
        </>
    )
}
